<template>
  <div class="component-body">
    <el-slider v-model="value1"></el-slider>
    <el-slider v-model="value2" disabled></el-slider>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      value1: 50,
      value2: 40
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/11/Slider/index.vue